import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { HeaderProps } from './Header';
import { useState } from 'react';
import { IsoDropdown, IsoDropdownItem, useConfig } from '@ibe/components';
import Link from 'next/link';
import { getLinkUrl } from '@/components/linkList/Link';

interface Props {
  loginLabel: HeaderProps['loginLabel'];
  logoutLabel: HeaderProps['logoutLabel'];
  bookingListLabel?: HeaderProps['bookingListLabel'];
  bookingListLink?: HeaderProps['bookingListLink'];
  openLoginModal: () => void;
  logout: () => void;
  isLoggedIn?: boolean;
  firstname?: string;
  lastname?: string;
}

const LoginButton = (props: Props) => {
  const {
    loginLabel,
    bookingListLabel,
    bookingListLink,
    openLoginModal,
    logoutLabel,
    logout,
    isLoggedIn,
    firstname,
    lastname
  } = props;
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleLogoutClick = () => {
    logout();
  };
  const config = useConfig();
  return (
    <div className="login-button-dropdown-container">
      <IsoDropdown
        isOpen={showPopup}
        onDropdownToggle={isLoggedIn ? togglePopup : openLoginModal}
        title={isLoggedIn ? `${firstname}, ${lastname}` : loginLabel}
        icon={faUserCircle}
      >
        {bookingListLabel && bookingListLink && (
          <IsoDropdownItem tag={Link} href={getLinkUrl(bookingListLink, config)}>
            {bookingListLabel}
          </IsoDropdownItem>
        )}
        <IsoDropdownItem onClick={handleLogoutClick} role="button">
          {logoutLabel}
        </IsoDropdownItem>
      </IsoDropdown>
    </div>
  );
};

export default LoginButton;
